/**
 * @packageDocumentation
 * @module ClientAppService
 */
import { AppService } from "@cervval.js/common/services";

export interface ClientAppService extends AppService {
    /**
     * @returns the client i18n language
     */
    getI18nLanguage(): string;
}
